/**
 * Converts a byte value into a human-readable string with appropriate units.
 *
 * @param bytes The size in bytes to format.
 * @param decimals The number of decimal places to round to (default is 2).
 * @returns A formatted string representing the size in bytes, KB, MB, or GB.
 */
export const prettifyBytes = (bytes: number, decimals = 2): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = sizes[i];
  const value = parseFloat((bytes / Math.pow(k, i)).toFixed(decimals));

  return `${value} ${size}`;
};

/**
 * Converts an array of strings into a comma-separated string with appropriate conjunction.
 *
 * @param items The array of strings to format.
 * @returns A string where items are separated by commas, with "and" before the last item.
 *          Returns an empty string if the array is empty, the single item if only one, or
 *          "x and y" if two items.
 */
export const formatArrToCommaSeparatedString = (items: string[]): string => {
  const count = items.length;

  if (count === 0) {
    return '';
  } else if (count === 1) {
    return items[0];
  } else if (count === 2) {
    return `${items[0]} and ${items[1]}`;
  } else {
    return `${items.slice(0, -1).join(', ')}, and ${items[count - 1]}`;
  }
};
